import axios from "axios";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import {
  SOMETHING_WENT_WRONG_API,
  UNAUTHORISED,
  NOT_FOUND,
  BAD_REQUEST,
} from "../utils/GlobalConstants";

let baseURL = process.env.REACT_APP_SURVEY_BASE_URL;
let GPCName=process.env.REACT_APP_GPC_NAME;
let GPCUserName=process.env.REACT_APP_USER_NAME;
let GPCEmail=process.env.REACT_APP_GPC_EMAIL;
let GPCRole=process.env.REACT_APP_GPC_ROLE;

const axiosClient = axios.create();
axiosClient.defaults.baseURL = baseURL;
axiosClient.defaults.headers = {
  "Content-Type": "application/json",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*",
  crossDomain: true,
};
axiosClient.interceptors.request.use(
  function (config) {
    const accesstoken = Cookies.get("access_token");
    // const bytes = accesstoken && CryptoJS.AES.decrypt(accesstoken, DECRYPT_KEY);
    // const decryptData = bytes && JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    const decodeAccess = jwtDecode(accesstoken);
    const expireTime = decodeAccess.exp;
    const currentTime = new Date().getTime() / 1000;
    if (currentTime < expireTime) {
      config.headers["Authorization"] = `Bearer ${accesstoken}`;
      config.headers["X-GPC-name"]=GPCName;
      config.headers["X-GPC-username"]=GPCUserName;
      config.headers["X-GPC-email"]=GPCEmail;
      config.headers["X-GPC-role"]=GPCRole;

    } else {
      document.cookie = "";
      Cookies.remove("accesstoken");
      Cookies.remove("d_12")
      localStorage.clear()
      window.location.href = "/fleet/login";
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export function getRequest(URL) {
  return axiosClient.get(`/${URL}`)
    .then((response) => response.data)
    .catch((error) => {
      if (error?.status === 500) {
        error.message = SOMETHING_WENT_WRONG_API;
      } else if (error?.status === 400) {
        error.message = BAD_REQUEST;
      } else if (error?.status === 403 || error?.status === 401) {
        error.message = UNAUTHORISED;
      } else if (error?.status === 404) {
        error.message = NOT_FOUND;
      }
      throw error;
    });
}

export function getRequestBlob(URL) {
  return axiosClient
    .get(`/${URL}`, {
      headers: {
        Accept: "application/pdf",
      },
      responseType: "blob",
    })
    .then((response) => response.data)
    .catch((error) => {
      if (error?.status === 500) {
        error.message = SOMETHING_WENT_WRONG_API;
      } else if (error?.status === 400) {
        error.message = BAD_REQUEST;
      } else if (error?.status === 403 || error?.status === 401) {
        error.message = UNAUTHORISED;
      } else if (error?.status === 404) {
        error.message = NOT_FOUND;
      }
      throw error;
    });
}

export function postRequestBlob(URL, payload) {
  return axiosClient
    .post(`/${URL}`, payload, {
      headers: {
        Accept: "application/pdf",
      },
      responseType: "blob",
    })
    .then((response) => response.data)
    .catch((error) => {
      if (error?.status === 500) {
        error.message = SOMETHING_WENT_WRONG_API;
      } else if (error?.status === 400) {
        error.message = BAD_REQUEST;
      } else if (error?.status === 403 || error?.status === 401) {
        error.message = UNAUTHORISED;
      } else if (error?.status === 404) {
        error.message = NOT_FOUND;
      }
      throw error;
    });
}

export function getRequestById(URL) {
  return axiosClient.get(`/${URL}`)
    .then((response) => response.data)
    .catch((error) => {
      if (error?.status === 500) {
        error.message = SOMETHING_WENT_WRONG_API;
      } else if (error?.status === 400) {
        error.message = BAD_REQUEST;
      } else if (error?.status === 403 || error?.status === 401) {
        error.message = UNAUTHORISED;
      } else if (error?.status === 404) {
        error.message = NOT_FOUND;
      }
      throw error;
    });
}

export function postRequest(URL, payload) {
  return axiosClient.post(`/${URL}`, payload)
    .then((response) => response)
    .catch((error) => {
      if (error?.status === 500) {
        error.message = SOMETHING_WENT_WRONG_API;
      } else if (error?.status === 400) {
        error.message = BAD_REQUEST;
      } else if (error?.status === 403 || error?.status === 401) {
        error.message = UNAUTHORISED;
      } else if (error?.status === 404) {
        error.message = NOT_FOUND;
      }
      throw error;
    });
}

export function patchRequest(URL, payload) {
  return axiosClient.put(`/${URL}`, payload)
    .then((response) => response)
    .catch((error) => {
      if (error?.status === 500) {
        error.message = SOMETHING_WENT_WRONG_API;
      } else if (error?.status === 400) {
        error.message = BAD_REQUEST;
      } else if (error?.status === 403 || error?.status === 401) {
        error.message = UNAUTHORISED;
      } else if (error?.status === 404) {
        error.message = NOT_FOUND;
      }
      throw error;
    });
}

export function deleteRequest(URL) {
  return axiosClient.delete(`/${URL}`)
    .then((response) => response)
    .catch((error) => {
      if (error?.status === 500) {
        error.message = SOMETHING_WENT_WRONG_API;
      } else if (error?.status === 400) {
        error.message = BAD_REQUEST;
      } else if (error?.status === 403 || error?.status === 401) {
        error.message = UNAUTHORISED;
      } else if (error?.status === 404) {
        error.message = NOT_FOUND;
      }
      throw error;
    })
}

export function deleteMultiRequest(URL, payload) {
  return axiosClient.delete(`/${URL}`, {
    data: payload,
  });
}
